import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  deductionList: [],
  pagination: {},
  filters: {
    page: 1,
    per_page: 20,
    status: "",
    type: "",
    reference: "",
    client_customer_rel_id: "",
    invoice_source_id: "",
  },
  isFetching: false,
  selectedRows: [],
  isheaderchecked: false,
  isrowselected: false,
};

export default function deductionReducer(state = initialState, action) {
  switch (action.type) {
    case ReducersTypes.SET_DEDUCTION_FETCHING:
      return { ...state, isFetching: action.payload };

    case ReducersTypes.SET_DEDUCTION_LIST:
      return {
        ...state,
        deductionList: action.payload.deductionList || [],
        pagination: action.payload.pagination || {},
        filters: action.payload.filters || state.filters,
        isFetching: false,
      };

    case ReducersTypes.SET_DEDUCTION_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case ReducersTypes.UPDATE_DEDUCTION: {
      const idx = state.deductionList.findIndex(
        (d) => d.id === action.payload.id
      );
      const updated = [...state.deductionList];
      if (idx >= 0) {
        updated[idx] = { ...updated[idx], ...action.payload };
      } else {
        updated.unshift(action.payload);
      }
      return { ...state, deductionList: updated };
    }

    case ReducersTypes.DELETE_DEDUCTION:
      return {
        ...state,
        deductionList: state.deductionList.filter(
          (d) => d.id !== action.payload
        ),
      };

    case ReducersTypes.EDIT_DEDUCTIONS:
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
        isheaderchecked: action.payload.isheaderchecked,
        isrowselected:
          action.payload.selectedRows && !!action.payload.selectedRows.length,
      };

    default:
      return state;
  }
}
